import $$ from 'cmn-utils'

const baseUrl = "/api/sys/organs/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    getByUnit: (params) => {
        return $$.get(baseUrl + 'get-by-unit', params)
    },

}